import { CommentsList, Container, Notification } from '../../components';
import RealEstateAmaltheare from './real-estate-amaltheare';
import RealEstateDashboard from './real-estate-dashboard';
import RealEstateExpertise from './real-estate-expertise';
import RealEstateIntro from './real-estate-intro';
import RealEstateRenty from './real-estate-renty';
import styles from './real-estate.module.css';

function RealEstatePage() {
  return (
    <main className={styles.wrapper}>
      <RealEstateIntro />
      <RealEstateExpertise />
      <RealEstateAmaltheare />
      <RealEstateRenty />
      <Container>
        <Notification
          className={styles.notification}
          title="HAVE A REAL ESTATE APP IN MIND?"
          buttonName="Estimate my project"
          href="/contact"
        />
      </Container>
      <RealEstateDashboard />
      <section className={styles.clients}>
        <Container>
          <h2 className={styles.clients_title}>REVIEWS FROM OUR CLIENTS</h2>
          <CommentsList />
        </Container>
      </section>
      <Container>
        <Notification
          title="NEED A PROFESSIONAL APPROACH TO YOUR REAL ESTATE PROJECT?"
          buttonName="Get a consultation"
          href="/contact"
        />
      </Container>
    </main>
  );
}

export default RealEstatePage;
